import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Music2, VolumeX } from "lucide-react";
import { useMusicOn, setMusicOn, startMusic, stopMusic } from "@/lib/gameMusic";

const GAME_PATHS = /^\/(spiele|zwei-herzen|herz-laeufer|zuckerherz|lotto)(\/|$)/;

export function GameMusicController() {
  const { pathname } = useLocation();
  const on = useMusicOn();
  const active = on && GAME_PATHS.test(pathname);
  useEffect(() => {
    if (!active) { stopMusic(); return undefined; }
    startMusic();
    const vis = () => (document.hidden ? stopMusic() : startMusic());
    document.addEventListener("visibilitychange", vis);
    return () => document.removeEventListener("visibilitychange", vis);
  }, [active]);
  return null;
}

export function MusicToggle({ dark = false, compact = false }) {
  const on = useMusicOn();
  const base = dark ? (on ? "bg-white/15 text-white ring-1 ring-white/25" : "bg-white/10 text-white/60") : (on ? "bg-gradient-to-r from-fuchsia-500 to-rose-500 text-white shadow-md shadow-rose-300/50" : "bg-white/80 text-slate-500 ring-1 ring-pink-100");
  return (
    <button type="button" onClick={() => setMusicOn(!on)} data-testid="game-music-toggle" aria-pressed={on} aria-label={on ? "Musik ausschalten" : "Musik einschalten"}
      className={`shrink-0 inline-flex items-center gap-1.5 h-10 ${compact ? "w-10 justify-center" : "px-3.5"} rounded-full text-sm font-bold backdrop-blur-md transition-[transform,background-color] active:scale-95 ${base}`}>
      {on ? <span className="eq-bars" aria-hidden><i /><i /><i /><i /></span> : <VolumeX className="w-4 h-4" />}
      {!compact && <span className="inline-flex items-center gap-1"><Music2 className="w-3.5 h-3.5" />{on ? "Musik" : "Aus"}</span>}
    </button>
  );
}
